import isEmpty from 'lodash/isEmpty';
import {useEffect, useState} from 'react';
import css from './Cgm.scss';
import {ReportService} from './ReportService';

const Cgm = props => {
    const [ContentPDF, setContentPDF] = useState('');
    const [loading, setLoading] = useState(true);
    const [APIerror, setAPIerror] = useState(false);

    const arrayBufferToBase64 = buffer => {
        let binary = '';
        const bytes = new Uint8Array(buffer);

        for (let i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
        }

        return window.btoa(binary);
    };

    useEffect(() => {
        let isMounted = true; // guard to avoid state updates after unmount

        const loadReports = async () => {
            try {
                const [reportData] = await Promise.all([ReportService()]);

                if (!isMounted) return;

                // CGM2 Image PDF (base64)
                if (!isEmpty(reportData?.[0])) {
                    const pdfImgCgm2 =
                        reportData[0].imageList[0].pdfImg.array[0];
                    const base64imageCgm2 = arrayBufferToBase64(pdfImgCgm2);

                    setContentPDF(base64imageCgm2);
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                // console.log(err);
                if (isMounted) setAPIerror(true);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        loadReports();

        return () => {
            isMounted = false;
        };
    }, []); // no missing dependency warnings

    if (loading) {
        return <div className={css.errorStyling}>Loading CGM reports...</div>;
    }

    if (APIerror) {
        return (
            <div className={css.errorStyling}>
                The CGM report for this member cannot be displayed at this time.
            </div>
        );
    }

    return (
        <div className={css.cgmStyling}>
            {/* CGM2 IMAGE (Base64) */}
            {ContentPDF && (
                <img
                    className={css.embedStyling}
                    id="dexcomPdfCgm2"
                    src={`data:image/jpeg;base64,${ContentPDF}`}
                    alt="CGM2 PDF Image"
                />
            )}
        </div>
    );
};

export default Cgm;
